import { t } from '@/utils/i18n'
import React, { useRef, useEffect } from 'react'
import { Toast } from 'antd-mobile'
import { cal } from '@/utils'
// import useCorpSettingStore from '@/stores/corp-setting'
import styles from './AddInput.module.less'

interface AddInputProps {
  status: boolean
  onConfirm: (value: number) => void
  onClose: () => void
}

const AddInput: React.FC<AddInputProps> = (props) => {
  // const { corpSetting } = useCorpSettingStore()
  // const { qualityPrecision } = corpSetting
  const qualityPrecision = 0
  const { status, onConfirm, onClose } = props
  const addInput = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (status && addInput.current) {
      addInput.current.focus()
    }
  }, [status])

  function handleCancelInput() {
    clearValue()
    onClose()
  }

  function handleSubmit() {
    if (!addInput.current) return
    let val = addInput.current.value

    // 非法输入
    if (/[^\d.]/g.test(val) || !val) {
      clearValue()
      return
    }

    val = val.startsWith('.') ? '0' : val // 处理小数位

    // 数量限制为整数，但输入小数时
    if (qualityPrecision === 0 && val.indexOf('.') !== -1) {
      val = val.substr(0, val.indexOf('.'))
      Toast.show(t('不能输入小数'))

      clearValue()
      return
    }

    if (qualityPrecision !== 0) {
      const copyValueList = val.match(/\.+/g)
      if (copyValueList && copyValueList.length > 1) {
        val = val.substr(0, val.lastIndexOf('.'))
      }

      if (copyValueList) {
        const decimalPlace = cal.getDecimalPlace(Number(val))

        if (decimalPlace > qualityPrecision) {
          Toast.show(
            t('最多可填{{qualityPrecision}}位小数', {
              qualityPrecision: qualityPrecision,
            })
          )
          val = cal.getFloat(Number(val), qualityPrecision)
        } else {
          onConfirm(Number(val))
        }
      } else {
        onConfirm(Number(val))
      }

      clearValue()
      return
    }

    onConfirm(Number(val))
    clearValue()
  }

  function clearValue() {
    if (addInput.current) {
      addInput.current.value = ''
    }
  }

  return (
    <div className={styles['kp-modal-wrapper']}>
      <div className={styles['kp-mask']}></div>
      <div className={styles['kp-modal']}>
        <div className={styles['kp-title']}>{t('批量加购')}</div>
        <div className={styles['input']}>
          <input
            type="tel"
            pattern="[0-9]*"
            ref={addInput}
            maxLength={8}
            placeholder={t('填写数量')}
            name="num"
            defaultValue={''}
          />
        </div>
        <div className={styles['kp-button-wrapper']}>
          <div
            className={styles['kp-cancel']}
            onClick={handleCancelInput}
          >
            {t('取消')}
          </div>
          <button
            className={styles['kp-confirm']}
            onClick={handleSubmit}
          >
            {t('确定')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddInput
